import GlowEffect from "../common/GlowEffect";
import { useAboutData } from "../../hooks/useAboutData";
import { CUP_HOLDING_IMAGE } from "../../constants/imageConstants";

export default function AboutUsHeroSection() {
  const { data } = useAboutData();

  return (
    <>
      <section className="relative sm:py-12 px-0 md:px-0 md:min-h-[60vh] min-h-[80vh] flex">
        <GlowEffect direction="left" />

        <div className="grid md:grid-cols-[1fr_2fr] justify-center">
          {/* Left Content - 3D Graphics */}
          <div className="relative flex order-last md:order-first">
            {/* Background Clouds */}
            <div className="absolute inset-0 -top-24 sm:-top-10 left-0 flex items-center">
              <img
                src={CUP_HOLDING_IMAGE}
                alt="3D Clouds"
                className="w-60 sm:w-80 z-10 lg:w-[250px] xl:w-[320px] h-auto animate-float"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-6 lg:space-y-14 z-10 px-10 md:px-0 order-first md:order-last">
            <h1 className="text-4xl md:text-6xl xl:text-9xl font-bold leading-tight text-white tracking-wide w-full">
              <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent drop-shadow-[0px_4px_10px_rgba(255,255,255,0.25)]">
                {data.heroSection.title}
              </span>
            </h1>

            <p className="text-lg lg:text-xl text-[#d9d9d9] leading-relaxed max-w-2xl px-4 border-l-2">
              {data.heroSection.description}
            </p>
          </div>
        </div>
      </section>
      <h2 className="text-white text-center text-4xl md:text-6xl font-medium mb-2 tracking-wider uppercase py-8 md:py-16 bg-[#D9D9D9]/10">
        {data.heroSection.sectionTitle}
      </h2>
    </>
  );
}
